// extracted by mini-css-extract-plugin
module.exports = {"Container":"H2_Container__16p0p","Header":"H2_Header__MIy8u"};